import React, { useState, useEffect } from 'react';
import { AlertPopUp, MessageAlert, AlertPopUpPrimary } from './styles'

export const AlertMessage = (props) => {
    return (
        <AlertPopUp
            className={props.className ? props.className: ""}
            title={props.title}
            centered
            visible={props.visible}
            onCancel={props.onCancel}
            width={props.width}
            maskClosable={props.maskClosable}
            cancelText={props.cancelText || "CLOSE"}>
            {props.children}
        </AlertPopUp>
    )
}

export const AlertMessageSelfClose = (props) => {
    const [visible, setVisible] = useState(props.visible);

    const onCancel = () => {
        setVisible(false);
    }

    useEffect(() => {
        setVisible(props.visible);
    }, [props.value]);

    return (
        <AlertPopUp
            className="altPopup"
            title={props.title}
            centered
            visible={visible}
            onCancel={onCancel}
            width={props.width}
            cancelText={props.cancelText || "OKAY"}>
            {props.children}
        </AlertPopUp>
    )
}

export const AlertMessagePrimary = (props) => {
    return (
        <AlertPopUpPrimary
            className={props.className ? props.className: ""}
            title={props.title}
            centered
            visible={props.visible}
            onOk={props.onOk}
            onCancel={props.onCancel}
            width={props.width}
            cancelText={props.cancelText || "No,take me back"}
            okText={props.okText || "CONTINUE"}
        >{props.children}</AlertPopUpPrimary>
    )
}
